import PropTypes from 'prop-types';
import React from 'react';
import { Field} from  'react-final-form';
import { fullDate } from '../../../core/date';
import {
  ButtonGroup,
  Button,
  Modal,
} from 'react-bootstrap';
import HotelFeedbackLink from './HotelFeedbackLink';
import Griddle, { plugins, RowDefinition, ColumnDefinition } from 'griddle-react';

const styleConfig = {
  icons: {
    TableHeadingCell: {
      sortDescendingIcon: '▼',
      sortAscendingIcon: '▲',
    },
  },
  classNames: {
    Row: 'row-class',
    Table: 'table-striped table updated-stay-bids-table',
    Filter: 'updated-bids-modal-table-filter'
  },
  styles: {
    Filter: { fontSize: 18 },
  },
};

let checkedBidList = [];

class UpdatedBidsModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        isDisable : true 
    }
    this.checkboxFormatter = this.checkboxFormatter.bind(this);
    this.changeCheckBox    = this.changeCheckBox.bind(this);
    this.reOpenBid         = this.reOpenBid.bind(this);
    this.dateDisplay       = this.dateDisplay.bind(this);
  }

  componentWillMount() {
    checkedBidList = [];
  }

  changeCheckBox(e, cell) {
    if(e.target.checked){
      checkedBidList.push(cell.value);
      this.setState({
         isDisable : false
      })
    }
    if(e.target.checked == false){
        for( let i = 0; i < checkedBidList.length; i++){ 
           if ( checkedBidList[i] === cell.value) {
             checkedBidList.splice(i, 1); 
         }
       }
       if(checkedBidList.length ==0) {
          this.setState({
         isDisable : true
      })

       }
     }
  }

  reOpenBid() {
       this.props.updateReOpenBid(checkedBidList,(response)=>{
       this.props.requestBidsets(this.props.tourData.id);
       this.props.closeUpdate();
  });
  }

  checkboxFormatter = (cell, row) => {
    return (
      <input type='checkbox' onChange={(e) => this.changeCheckBox(e, cell)}/>
    )
  }
  
  dateDisplay = (row, rowIndex) => {
    return (
      <span> {fullDate(row.value)} </span>
      )
  }

  render() {
        const updatedBids = []
        this.props.bids.forEach((bid) => {
         if(bid.state == 'Stay Updated'){
          updatedBids.push(bid);
         }
    });  

    return (
      <div>
        <Modal dialogClassName="updated-bids-modal-dialog" show={this.props.showUpdate} onHide={this.props.closeUpdate}>
          <Modal.Header closeButton>
            <Modal.Title>
            Stays Updated
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <h5>The Stay Dates for following bids has been Updated.</h5>
          <p className="text-muted">Please select the bids for which you want to send the rebid requests.</p>
               <Griddle
                      data={updatedBids}
                      styleConfig={styleConfig}
                      components={{
                        SettingsToggle: () => <span />,
                        Pagination: () => <span />,
                      }}
                    >
                      <RowDefinition>
                        <ColumnDefinition id="id" title=" " customComponent={this.checkboxFormatter}/>
                        <ColumnDefinition id="name" title="Hotel" />
                        <ColumnDefinition id="group" title="Group" />
                        <ColumnDefinition id="location" title="Location" />
                        <ColumnDefinition id="start" title="Check In Date" customComponent={this.dateDisplay}/>
                        <ColumnDefinition id="end" title="Check Out Date" customComponent={this.dateDisplay}/>
                      </RowDefinition>
             </Griddle>
              <Button title="Send" disabled={this.state.isDisable} bsStyle="info" onClick={this.reOpenBid} className="updated-bids-send-btn">
                  <i className="fa fa-envelope fa-lg" />
                  <i className="fa fa-email fa-lg" /> Send
              </Button>
              <Button title="Cancel" bsStyle="info" className="updated-bids-cancel-btn" onClick={this.props.closeUpdate}>
                  <i className="fa fa-trash fa-lg" /> Cancel
              </Button>
          </Modal.Body>
          <Modal.Footer >
            <HotelFeedbackLink/>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}


UpdatedBidsModal.propTypes = {
  showUpdate: PropTypes.bool.isRequired,
  closeUpdate: PropTypes.func.isRequired
};

UpdatedBidsModal.defaultProps = {
  proposal: {
    contacts: [],
    bids: [],
  },
};
export default UpdatedBidsModal;



// WEBPACK FOOTER //
// src/routes/tours/components/UpdatedBidsModal.js